import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Passthrough interceptor used in all non-mock build configurations (dev, qa, prod).
 * This file contains NO mock data imports, ensuring mock data is never bundled
 * in deployed builds. The local build uses fileReplacements to swap in interceptor.ts
 * which conditionally serves mock data based on SEU_ENVIRONMENT.mock.
 */
export const SEU_MOCK_INTERCEPTOR: HttpInterceptorFn = (request, next) =>
  next(request);
